import { useEffect, useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { Icon } from '../icons'
import { useToast } from '../ui/Toaster'

/**
 * Link que a regra do canal não deixa sair (Configurações → Links). Bloqueia de verdade — um
 * link externo num marketplace pode custar a conta —, mas não deixa a pessoa sem saída: ela tira
 * o link, ou pede ao gestor para liberar o domínio. O rascunho fica onde estava.
 */
export function LinkBlockedPopup({
  conversationId,
  domains,
  scopeLabel,
  text,
  onClose,
}: {
  conversationId: string
  domains: string[]
  scopeLabel: string
  text: string
  onClose: () => void
}) {
  const toast = useToast()
  const qc = useQueryClient()
  const [busy, setBusy] = useState(false)
  const ref = useRef<HTMLButtonElement>(null)
  useEffect(() => ref.current?.focus(), [])

  return (
    <>
      <div className="modal-back" onClick={onClose} />
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label="Link não permitido"
        onKeyDown={(e) => { if (e.key === 'Escape') { e.preventDefault(); onClose() } }}
      >
        <div className="modal-h">
          <Icon name="warn" size={15} />
          Link não permitido neste canal
          <button className="icon-btn" onClick={onClose} aria-label="Fechar">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-b">
          <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.5 }}>
            {domains.length === 1 ? 'O domínio ' : 'Os domínios '}
            <b>{domains.join(', ')}</b> {domains.length === 1 ? 'não é permitido' : 'não são permitidos'} em{' '}
            <b>{scopeLabel}</b>. Tire o link da mensagem ou peça ao gestor para liberar.
          </p>
          <p className="modal-note">Nada foi enviado. A sua mensagem continua no campo de resposta.</p>
          <div className="modal-f">
            <button ref={ref} className="btn ghost" onClick={onClose}>Voltar e editar</button>
            <button
              className="btn pri"
              disabled={busy}
              onClick={async () => {
                setBusy(true)
                try {
                  await api.linkRequest({ conversationId, domains, sample: text.slice(0, 500) })
                  toast('Pedido enviado ao gestor. Quando ele liberar, é só enviar de novo.')
                  // O ponto na engrenagem do gestor (se for ele mesmo aqui) aparece na hora.
                  void qc.invalidateQueries({ queryKey: ['link-requests'] })
                  onClose()
                } catch {
                  toast('Não consegui registrar o pedido.')
                  setBusy(false)
                }
              }}
            >
              Pedir liberação ao gestor
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
